// extracted by mini-css-extract-plugin
module.exports = {"ToolbarDiv":"EditPromotionDialog_ToolbarDiv__2Fn5a","Label":"EditPromotionDialog_Label__2jw2T"};